import { todayIso, type PlannedEvent } from '@fin/shared';


import { useState } from 'react';
import { Button, ConfirmButton, Field, Icon, Input, Loading, Modal, Money, NumberInput, Section, cx, useAction } from '../../components/ui.tsx';
import { del, patch, post } from '../../lib/api.ts';

import { dateLong } from '../../lib/format.ts';
import { invalidate, useQuery } from '../../lib/query.ts';



export function EventsSection() {
  const q = useQuery<PlannedEvent[]>('/events');
  const [edit, setEdit] = useState<PlannedEvent | 'new' | null>(null);
  return (
    <Section title="События и крупные траты" tone="event" aside={<Button size="sm" onClick={() => setEdit('new')}><Icon name="plus" size={16} /> Событие</Button>}>
      {!q.data ? <Loading /> : (
        <ul className="ledger">
          {q.data.map((e) => (
            <li key={e.id} className={cx('ledger-row', e.done && 'muted')}>
              <button type="button" className="ledger-main link-like" onClick={() => setEdit(e)}>
                <span className="event-date">{dateLong(e.date)}</span>{e.title}
              </button>
              <Money value={e.amount} currency={e.currency} />
            </li>
          ))}
          {!q.data.length ? <li className="muted">Событий нет. Добавьте дни рождения, отпуск, налоги — всё, на что нужно отложить заранее.</li> : null}
        </ul>
      )}
      {edit ? <EventModal ev={edit === 'new' ? undefined : edit} onClose={() => setEdit(null)} /> : null}
    </Section>
  );
}

export function EventModal({ ev, onClose }: { ev?: PlannedEvent; onClose: () => void }) {
  const [title, setTitle] = useState(ev?.title ?? '');
  const [date, setDate] = useState(ev?.date ?? todayIso());
  const [amount, setAmount] = useState<number | null>(ev?.amount ?? null);
  const [done, setDone] = useState(ev?.done ?? false);
  const { busy, run } = useAction();
  const save = () => run(async () => {
    const body = { title, date, amount: amount ?? 0, currency: ev?.currency ?? 'RUB', done };
    if (ev) await patch(`/events/${ev.id}`, body); else await post('/events', body);
    invalidate('/events', '/dashboard');
    onClose();
  }, 'Событие сохранено');
  return (
    <Modal className="modal-form" title={ev ? ev.title : 'Новое событие'} onClose={onClose} footer={<>
      {ev ? <ConfirmButton size="md" onConfirm={async () => { await del(`/events/${ev.id}`); invalidate('/events', '/dashboard'); onClose(); }}>Удалить</ConfirmButton> : <span />}
      <div className="row-gap"><Button onClick={onClose}>Отмена</Button><Button variant="primary" busy={busy} onClick={save}>Сохранить</Button></div>
    </>}>
      <form className="form" onSubmit={(e) => { e.preventDefault(); void save(); }}>
        <Field label="Событие"><Input value={title} onChange={(e) => setTitle(e.target.value)} autoFocus required /></Field>
        <div className="form-row">
          <Field label="Дата" className="grow"><Input type="date" value={date} onChange={(e) => setDate(e.target.value)} /></Field>
          <Field label="Сумма" className="grow"><NumberInput value={amount} onChange={setAmount} /></Field>
        </div>
        {ev ? <label className="check"><input type="checkbox" checked={done} onChange={(e) => setDone(e.target.checked)} /> Уже прошло</label> : null}
        <button type="submit" hidden />
      </form>
    </Modal>
  );
}
